<template>
  <div id="app">
    <heads v-if="!isHiddenRoute" />
    <router-view />
    <foots v-if="!isHiddenRoute" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''" />
  </div>
</template>
<script>
// import { siteLanguage } from '@/api/login/login'
export default {
  name: 'App',
  data() {
    return {

    }
  },
  computed: {
    isHiddenRoute() {
      const hiddenRoutes = ['/document'] // 需要隐藏表头的路径
      return hiddenRoutes.includes(this.$route.path)
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {

  }
}
</script>
<style>
@import './assets/css/editor.content.css';
@import './assets/css/antd.css';
@import './assets/css/animate.min.css';
@import './assets/css/swiper.min.css';
@import './assets/css/common.css';
@import './assets/css/main.css';
</style>
